import { Controller } from '@hotwired/stimulus';

export default class ChartingChatDraggableController extends Controller {
  static VIEWPORT_MARGIN = 20;

  start(event) {
    event.preventDefault();

    this.#rememberGrabOffset(event);
    this.#lockPositionToViewport();

    event.currentTarget.setPointerCapture(event.pointerId);
  }

  move(event) {
    if (!event.currentTarget.hasPointerCapture(event.pointerId)) return;

    this.element.style.left = `${this.#constrainedLeft(event)}px`;
    this.element.style.top = `${this.#constrainedTop(event)}px`;
  }

  get #maxLeft() {
    return window.innerWidth
      - this.element.offsetWidth
      - ChartingChatDraggableController.VIEWPORT_MARGIN;
  }

  get #maxTop() {
    return window.innerHeight
      - this.element.offsetHeight
      - ChartingChatDraggableController.VIEWPORT_MARGIN;
  }

  #rememberGrabOffset(event) {
    const rect = this.element.getBoundingClientRect();

    this.offsetX = event.clientX - rect.left;
    this.offsetY = event.clientY - rect.top;
  }

  #lockPositionToViewport() {
    const rect = this.element.getBoundingClientRect();

    this.element.style.left = `${rect.left}px`;
    this.element.style.top = `${rect.top}px`;
  }

  #constrainedLeft(event) {
    return ChartingChatDraggableController.#clamp(
      event.clientX - this.offsetX,
      ChartingChatDraggableController.VIEWPORT_MARGIN,
      this.#maxLeft
    );
  }

  #constrainedTop(event) {
    return ChartingChatDraggableController.#clamp(
      event.clientY - this.offsetY,
      ChartingChatDraggableController.VIEWPORT_MARGIN,
      this.#maxTop
    );
  }

  static #clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
  }
}
